import React, { Component } from "react";
import { Navbar, Nav, Button, Container } from "react-bootstrap";

import "./Compnavbar.css";

class Compnavbar extends Component {
  render() {
    return (
      <Navbar expand="lg" fixed="top" variant="dark">
        <Container>
          <Navbar.Brand href="#home">
            <img
              className="germlogo"
              src="./assets/images/logo.svg"
              alt="logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/product">Products</Nav.Link>
              <Nav.Link href="/service">Services</Nav.Link>
              <Nav.Link href="/contact">Contact</Nav.Link>
              <Button
                className="button rounded-pill"
                variant="danger"
                size="lg" href="/contact"
              >
                GET A QUOTE
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default Compnavbar;
